"use client";

import { LazyMotion, domMax } from "framer-motion";
import type { ReactNode } from "react";

/**
 * LazyMotion wrapper.
 *
 * Tree-shakes framer-motion: only the features explicitly requested in
 * `features={domMax}` are bundled. Reduces framer-motion runtime from
 * ~80 KiB to ~40 KiB.
 *
 * domMax includes: animations, exit, variants, drag, layout (layoutId).
 * We need layout because Header `MagneticLink` + `Reviews tab underline`
 * + `mobile menu indicator` use `layoutId`.
 *
 * Requires every `motion.X` JSX usage to be imported as `m as motion`
 * (or `m`) from framer-motion so tree-shaking actually kicks in.
 */
export function MotionProvider({ children }: { children: ReactNode }) {
  return <LazyMotion features={domMax}>{children}</LazyMotion>;
}
